module.exports = __webpack_public_path__ + "static/media/rectangle-18.d3c0c906.svg";